
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Alert } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles/index";
import Divider from "@material-ui/core/Divider/index";

const useStyles = makeStyles({
    list: {
        width: 400,
        height: "100vh",
    },
    card: {
        margin: "30px",
    },
    pointer: {
        cursor: "pointer",
    },
    progresRoot: {
        width: "100%",
        padding: "32px 16px",
    },
    progress: {
        margin: "auto",
        display: "block",
        color: "#231B88",
    },
});



export default function Edit(props) {

    const { onHide, show, chooseDeviceId, onDeviceLogs } = props;
    const [dataLogs, setDataLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const classes = useStyles();

    useEffect(() => {
        setIsLoading(true);
        onDeviceLogs(chooseDeviceId)
            .then((res) => {
                setDataLogs(res.data);
                setIsLoading(false);
                setIsError(false);
            })
            .catch((err) => {
                setIsLoading(false);
                setIsError(true);
            });
    }, [chooseDeviceId, onDeviceLogs]);

    return (
        <Modal
            onHide={onHide}
            show={show}
            size="lg"
            aria-labelledby="edit"
            centered
            className="modal p-5"
        >
            <Modal.Header closeButton>
                <Modal.Title id="Edit">Loqlar </Modal.Title>
            </Modal.Header>
            <Modal.Body className="log-body-modal">
                {isLoading ? (
                    <div className={classes.progresRoot}>
                        <CircularProgress className={classes.progress} />
                    </div>
                ) : !isLoading && !isError ? (
                    <div className="drawer-body" >

                        {dataLogs.length && dataLogs ? dataLogs.map((item, index) => {
                            return (
                                <div key={index} className="mt-5">
                                    <p>User id: {item?.UserId}</p>
                                    <p>Verify: {item?.Verify}</p>
                                    <p>InOut: {item?.InOut}</p>
                                    <p>Date time: {item?.DateTime}</p>
                                 
                                    <Divider/>

                                </div>
                            )
                        })
                            :
                            <div  className="nodata-log"> Data yoxdur.</div>
                        }
                    </div>
                ) : (
                    <div className="p-5">
                        <Alert variant="info">Xəta baş verdi.</Alert>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
}
